import React from "react"

import BlackButton from "@src/components/Buttons/BlackButton"
import GhostButton from "@src/components/Buttons/GhostButton"
import LoadingSpinner from "@src/components/loading-spinner"

export interface ConfirmModalProps {
  allowCancelOnBackground?: boolean
  cancelButtonText?: string
  confirmButtonText?: string
  isProcessing?: boolean
  message: string
  onCancel: () => void
  onConfirm: () => void
  title?: string
}
export default function ConfirmModal({
  allowCancelOnBackground = true,
  cancelButtonText = "Cancel",
  confirmButtonText = "Confirm",
  isProcessing = false,
  message,
  onCancel,
  onConfirm,
  title,
}: ConfirmModalProps) {
  return (
    <>
      <button
        className="bottom-0 left-0 right-0 top-0 h-full w-full z-[99998] block fixed bg-gray-900/50"
        data-modal-background-close-enabled={
          allowCancelOnBackground && !isProcessing
        }
        onClick={() => (allowCancelOnBackground ? onCancel() : () => {})}
      />
      <div className="bg-white rounded shadow-sm left-1/2 p-4 md:p-8 fixed top-1/2 transition-opacity -translate-x-1/2 -translate-y-1/2 w-4/5 max-w-md z-[99999]">
        {title && (
          <h4
            className="font-browser text-lg font-medium"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <p className="mb-4" dangerouslySetInnerHTML={{ __html: message }} />
        {isProcessing && (
          <div className="mb-2">
            <LoadingSpinner size={32} />
          </div>
        )}
        <div className="mb-3 w-full">
          <BlackButton
            additionalClasses="block w-full"
            disabled={isProcessing}
            onClick={() => onConfirm()}
            text={confirmButtonText}
          />
        </div>
        <div className="text-center">
          <GhostButton
            additionalClasses="inline-block w-1/2"
            disabled={isProcessing}
            onClick={() => onCancel()}
            text={cancelButtonText}
          />
        </div>
      </div>
    </>
  )
}
